import { render, staticRenderFns } from "./WhatsappThread.vue?vue&type=template&id=348eb7da&scoped=true&"
import script from "./WhatsappThread.vue?vue&type=script&lang=js&"
export * from "./WhatsappThread.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappThread.vue?vue&type=style&index=0&id=348eb7da&lang=scss&scoped=true&"
import style1 from "./WhatsappThread.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348eb7da",
  null
  
)

export default component.exports